import { addLabels, captureError } from '@otto-ec/global-resources/apm';
import type { ErrorReporting } from './ErrorReporting.ts';

const DEFAULT_LABELS = { team: 'reptile', service: 'dundee' };

export const errorReporting: ErrorReporting = {
    report: ({ error, type }) =>
        captureError(error instanceof Error ? error : new Error(String(error)), DEFAULT_LABELS, { type }),
    addLabels: (labels) => addLabels(labels),
};
